export default import.meta.ROLLDOWN_FILE_URL_rTOVBAbseenyPGYLOP0JOQ